import { lazy, Suspense, useEffect } from "react";
import { useUiStore } from "hooks/useUiStore";
import { Navigate, Route, Routes } from "react-router-dom";
import { AdminLayout } from "./adminLayout";
import { ProfileScreen } from "pages/profile/ProfileScreen";
import { toast } from "react-toastify";
import { NotFoundScreen } from "pages/notFound/notFoundScreen";
import { Loading } from "components/ui/loading";
import { PreguntasFrecuentes } from "components/preguntasFrecuentes/preguntas";

const lazyLoadHome = lazy(
  () =>
    import(
      /* webpackChunkName: "LazyLoad Home Routes" */ "./homeRoutes/homeRoutes"
    )
);

const lazyLoadExpedienteElectronico = lazy(
  () =>
    import(
      /* webpackChunkName: "LazyLoad Expediente Electrónico Routes" */ "./expedienteRoutes/expedienteRoutes"
    )
);

const lazyLoadMisReportes = lazy(
  () =>
    import(
      /* webpackChunkName: "LazyLoad Mis Reportes Routes" */ "./misReportesRoutes/misReportesRoutes"
    )
);

const lazyLoadSitioInteres = lazy(
  () =>
    import(
      /* webpackChunkName: "LazyLoad Mis Reportes Routes" */ "./sitioInteresRoutes/sitioInteresRoutes"
    )
);
const lazyLoadAceesosEdificio = lazy(
  () =>
    import(
      /* webpackChunkName: "LazyLoad Mis Reportes Routes" */ "./accesosEdificioRoutes/accesosEdificiosRoutes"
    )
);
const lazyLoadRequerimientosSistema = lazy(
  () =>
    import(
      /* webpackChunkName: "LazyLoad Requerimientos del Sistema Routes" */ "./requerimientosRoutes/requerimientosRoutes"
    )
);
const lazyLoadVideosTutoriales = lazy(
  () =>
    import(
      /* webpackChunkName: "LazyLoad Videos Tutoriales Routes" */ "./videosTutorialRoutes/videosTutorialRoutes"
    )
);

const lazyLoadInscripcionCursos = lazy(
  () =>
    import(
      /* webpackChunkName: "LazyLoad Inscripcion Cursos Routes" */ "./inscripcionCursosRoutes/inscripcionCursosRoutes"
    )
);
export const AdminRoutes = () => {
  const {
    openSnackBar,
    messageSnackBar,
    optionsSnackBar,
    openSnackBarMessage,
  } = useUiStore();

  const notify = () => toast(messageSnackBar, optionsSnackBar);

  useEffect(() => {
    if (openSnackBar) {
      notify();
      setTimeout(() => {
        openSnackBarMessage({
          status: false,
          message: "",
          optionsSnackBar: {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
            type: "success",
          },
        });
      }, 2000);
    }
    // eslint-disable-next-line
  }, [openSnackBar]);
  let host = window.location.host;
  let routesAdmin = [
    {
      path: "/inicio/*",
      Component: lazyLoadHome,
      name: "Inicio",
    },
    {
      path: "/expediente-electronico/*",
      Component: lazyLoadExpedienteElectronico,
      name: "Expediente Electrónico",
    },
    {
      path: "/mis-reportes/*",
      Component: lazyLoadMisReportes,
      name: "Mis Reportes",
    },
    {
      path: "/sitios-interes/*",
      Component: lazyLoadSitioInteres,
      name: "Mis Reportes",
    },
    {
      path: "/requerimientos-sistema",
      Component: lazyLoadRequerimientosSistema,
      name: "Requerimientos del Sistema",
    },
    {
      path: "/video-tutorial/*",
      Component: lazyLoadVideosTutoriales,
      name: "Videos Tutoriales",
    },
    // {
    //   path: "/inscripcion-Cursos",
    //   Component: lazyLoadInscripcionCursos,
    //   name: "Inscripción a Cursos",
    // },
    {
      path: "/accesos-edificios/*",
      Component: lazyLoadAceesosEdificio,
      name: "Acceso a Edificios",
    },
  ];

  return (
    <AdminLayout>
      <Suspense fallback={<Loading />}>
        <Routes>
          {routesAdmin.map(({ path, Component }) => (
            <Route key={path} path={path} element={<Component />} />
          ))}
          <Route path="mi-perfil" element={<ProfileScreen />} />
          <Route path="not-found" element={<NotFoundScreen />} />
          <Route path="/*" element={<Navigate to={"not-found"} />} />
          <Route
            path="preguntas-frecuentes"
            element={<PreguntasFrecuentes origen={"boton"} />}
          />
        </Routes>
      </Suspense>
    </AdminLayout>
  );
};
